import React, { Component } from 'react';
import DaumPostCode from 'react-daum-postcode';
import { Modal, Button } from 'antd';

class AddrSearch extends Component {

  handleAddress = data => {
    let fullAddress = data.address;
    let extraAddress = "";
    
    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }
    // console.log('우편번호', data.zonecode);
    // console.log('주소', fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    this.props.setAddrInfo({
      orZipCd: data.zonecode,
      addr: fullAddress,
    });
    
    this.props.modalClose();
  };

  render() {
    return (
      <Modal
        width={600}
        title="센터검색"
        cancelText={"취소"}
        okText={"확인"}
        closable={false}
        visible={this.props.modalOpen}
        onCancel={this.props.modalClose}
        footer={
          <Button
            onClick={this.props.modalClose}
          >닫기</Button>
        }
      >
        <DaumPostCode
          scriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"
          onComplete={this.handleAddress}
        />
      </Modal>
    );
  }

}

export default AddrSearch;
